import React from "react";
import PropTypes from "prop-types";
import {
  createTheme,
  Grid,
  LinearProgress,
  MuiThemeProvider,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { Button, DataTable, InfoPanel, SplitDialog } from "@invosys/invosys-ui";
import { ControlPointDuplicate, Equalizer } from "@material-ui/icons";
import { getColour } from "../actions/utils";

const timeFormatter = (date) => {
  const newDate = new Date(date);
  const hours = newDate.getHours();
  const mins = newDate.getMinutes();
  const ampm = hours > 11 ? "pm" : "am";
  const newHours = hours > 11 ? hours - 12 : hours;
  return `${newHours < 10 ? "0" : ""}${newHours}:${mins < 10 ? "0" : ""}${mins} ${ampm}`;
};

export default class DestinationSearch extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  pollTimeout = null;

  processResults = () => {
    console.log("Results", this.state.results);
  };

  pollSearch = async () => {
    if (!this.state.jwt) {
      await fetch("/getToken")
        .then((res) => res.json())
        .then((resJWT) => {
          this.setState({ jwt: resJWT.response.jwt });
        });
    }
    if (!this.state.pollId) {
      return;
    }
    const clientId =
      document.getElementById("react_currentAccountId").value ||
      document.getElementById("react_clientId").value;

    const fetchUrl = document.getElementById("destinationSearchURL").value;
    fetch(`${fetchUrl}?pollid=${this.state.pollId}&clientId=${clientId}`, {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${this.state.jwt}`,
      },
      method: "GET",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === "complete") {
          if (res.location) {
            fetch(res.location)
              .then((resp) => resp.json())
              .then((resp) => {
                console.log(resp);
                this.setState({ results: resp, pollId: null }, () => {
                  this.processResults();
                });
              })
              .catch((error) => {
                console.error(error);
              })
              .finally(() => {
                sessionStorage.removeItem("destinationSearch.searchedNumber");
                sessionStorage.removeItem("destinationSearch.pollId");
              });
          } else {
            this.setState({ results: res.data, pollId: null }, () => {
              this.processResults();
              sessionStorage.removeItem("destinationSearch.searchedNumber");
              sessionStorage.removeItem("destinationSearch.pollId");
            });
          }

          return;
        }

        this.pollTimeout = window.setTimeout(this.pollSearch, 2000);
      });
  };

  componentDidMount = () => {
    console.log("Mounted Destination Search");
    let pollId = sessionStorage.getItem("destinationSearch.pollId");
    const searchedNumber = sessionStorage.getItem(
      "destinationSearch.searchedNumber",
    );
    if (pollId === "undefined" || pollId === "null") {
      pollId = null;
    }
    this.setState({ pollId, searchedNumber }, () => {
      if (pollId) {
        this.pollSearch();
      }
    });
    const defaultTheme = {
      palette: {
        primary: {
          main: "#ce3030",
          contrastText: "#fff",
        },
        secondary: {
          main: "#2C2F30",
        },
        error: {
          main: "#d0021b",
        },
        text: {
          primary: "#000000",
          secondary: "#ffffff",
        },
      },
      overrides: {
        MuiTableCell: {
          sizeSmall: {
            whiteSpace: "pre",
            padding: "6px",
          },
        },
      },
    };
    const brandingOverRideText =
      document.getElementById("brandingOverRide")?.value || "{}";
    const brandingOverRide = JSON.parse(
      brandingOverRideText
        .replace(
          /&amp;|&lt;|&gt;|&#39;|&quot;|/g,
          (tag) =>
            ({
              "&amp;": "&",
              "&lt;": "<",
              "&gt;": ">",
              "&#39;": "'",
              "&quot;": '"',
            })[tag] || tag,
        )
        .replaceAll("\n", "{newline}"),
    );
    console.debug(brandingOverRide);
    if (
      brandingOverRide.primaryColour &&
      brandingOverRide.primaryColour !== "none"
    ) {
      defaultTheme.palette.primary.main = getColour(
        brandingOverRide.primaryColour,
      );
    }
    if (
      brandingOverRide.secondaryColour &&
      brandingOverRide.secondaryColour !== "none"
    ) {
      defaultTheme.palette.secondary.main = getColour(
        brandingOverRide.secondaryColour,
      );
    }
    this.setState({ defaultTheme });
  };

  submitSearch = () => {
    if (!this.state.searchedNumber || this.state.pollId) {
      return;
    }
    const clientId =
      document.getElementById("react_currentAccountId").value ||
      document.getElementById("react_clientId").value;
    this.setState({ pollId: "waiting" }, () => {
      fetch("/getToken")
        .then((res) => res.json())
        .then((resJWT) => {
          console.log("GetToken", resJWT);
          this.setState({ jwt: resJWT.response.jwt });
          const fetchUrl = document.getElementById(
            "destinationSearchURL",
          ).value;
          sessionStorage.setItem(
            "destinationSearch.searchedNumber",
            this.state.searchedNumber,
          );
          fetch(
            `${fetchUrl}?destination=${encodeURI(this.state.searchedNumber)}&clientId=${clientId}`,
            {
              headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${resJWT.response.jwt}`,
              },
              method: "GET",
            },
          )
            .then((res) => res.json())
            .then((res) => {
              this.setState({ pollId: res.pollId }, () => {
                sessionStorage.setItem("destinationSearch.pollId", res.pollId);
                this.pollTimeout = window.setTimeout(this.pollSearch, 2000);
              });
            })
            .catch((error) => {
              console.error(error);
              this.setState({ pollId: null });
            });
        });
    });
  };

  render = () => {
    return (
      <MuiThemeProvider
        theme={createTheme(
          this.state.defaultTheme || {
            palette: {
              primary: {
                main: "#333",
                contrastText: "#fff",
              },
            },
          },
        )}
      >
        <fieldset className="form-search" style={{ padding: "12px 0 0" }}>
          <Grid container className="frow frow-text frow-search">
            <Grid item>
              <label style={{ width: "75px" }}>Destination</label>
              <input
                type="text"
                defaultValue={this.state.searchedNumber}
                disabled={this.state.pollId}
                onChange={(evt) => {
                  const { value } = evt.target;
                  this.setState({ searchedNumber: value });
                }}
                onKeyUp={(evt) => {
                  if (evt.keyCode === 13) {
                    this.submitSearch();
                  }
                }}
              />
              <a
                style={{ position: "initial", marginLeft: "8px" }}
                href="#"
                className="button button-type-2"
                onClick={() => {
                  if (this.state.pollId) {
                    this.setState({ pollId: null });
                    sessionStorage.removeItem(
                      "destinationSearch.searchedNumber",
                    );
                    sessionStorage.removeItem("destinationSearch.pollId");
                    if (this.pollTimeout) {
                      window.clearTimeout(this.pollTimeout);
                    }
                  } else {
                    this.submitSearch();
                  }
                }}
              >
                {this.state.pollId ? "Cancel" : "Search"}
              </a>
            </Grid>
            {this.state.pollId ? (
              <LinearProgress
                color="secondary"
                style={{ width: "60px", height: "2em", margin: "4px 8px" }}
              />
            ) : (
              <div
                style={{
                  display: "inline-block",
                  width: "60px",
                  height: "1em",
                  margin: "4px 8px",
                }}
              ></div>
            )}
            <InfoPanel
              color="secondary"
              infoText={
                <Typography>
                  The search will carry on in the background so come back
                  periodically during this session to check
                </Typography>
              }
            />
          </Grid>
        </fieldset>
        {this.state.results && (
          <SplitDialog
            open={!!this.state.results}
            title={"Destination Search Results"}
            fullWidth
            maxWidth={"lg"}
            dialogContent={
              this.state.results.length ? (
                <DataTable
                  data={this.state.results.sort(
                    (a, b) =>
                      new Date(b.modified).getTime() -
                      new Date(a.modified).getTime(),
                  )}
                  columns={[
                    {
                      title: "Account",
                      render: (record) => (
                        <a href={`/services/edit?id=${record.module_group_id}`}>
                          {record.client_name} ({record.client_id})
                        </a>
                      ),
                    },
                    {
                      title: "Category",
                      field: "category",
                      render: (record) => (
                        <a href={`/services/edit?id=${record.module_group_id}`}>
                          {record.category}
                        </a>
                      ),
                    },
                    {
                      title: "Number",
                      field: "DDI",
                      render: (record) => (
                        <a href={`/services/edit?id=${record.module_group_id}`}>
                          {record.DDI}
                        </a>
                      ),
                    },
                    {
                      title: "Service",
                      field: "Service Name",
                      render: (record) => (
                        <React.Fragment>
                          <a
                            href={`/services/edit?id=${record.module_group_id}`}
                          >
                            {record["Service Name"]}
                            <br />
                            {["IVR", "ABR"].includes(record.service_type) ? (
                              <span style={{ fontSize: "0.87em" }}>
                                - {record.sub_group_name}
                              </span>
                            ) : null}
                          </a>
                        </React.Fragment>
                      ),
                    },
                    {
                      title: "Type",
                      field: "service_type",
                      render: (record) => (
                        <a href={`/services/edit?id=${record.module_group_id}`}>
                          {record.service_type}
                        </a>
                      ),
                    },
                    {
                      title: "Revision",
                      width: "150px",
                      render: (record) => {
                        const date = new Date(
                          record.modified,
                        ).toLocaleDateString("en-us", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        });
                        return (
                          <a
                            style={{ fontSize: "0.87em" }}
                            href={`/services/edit?id=${record.module_group_id}`}
                          >
                            {record.modified === record.created
                              ? "Created by"
                              : "Last editied by"}{" "}
                            {record.modified_user_firstname}{" "}
                            {record.modified_user_lastname}
                            <br />
                            at {timeFormatter(record.modified)} on {date}
                          </a>
                        );
                      },
                    },

                    {
                      title: "Actions",
                      render: (record) => (
                        <Grid container>
                          <Grid item>
                            <Tooltip title="Copy Service">
                              <a
                                href={`/services/copy?id=${record.module_group_id}`}
                              >
                                <ControlPointDuplicate
                                  color="secondary"
                                  fontSize="small"
                                />
                              </a>
                            </Tooltip>
                          </Grid>
                          <Grid item>
                            <Tooltip title="Reporting">
                              <a
                                href={`/report-hub/summary?diallednumbers=[${record.DDI}]`}
                              >
                                <Equalizer color="secondary" fontSize="small" />
                              </a>
                            </Tooltip>
                          </Grid>
                        </Grid>
                      ),
                    },
                  ]}
                  rowsPerPage={25}
                  dense
                />
              ) : (
                <Typography style={{ textAlign: "center" }} variant="h6">
                  No Results found
                </Typography>
              )
            }
            actions={[
              <Button
                variant="contained"
                color="secondary"
                key={"Close"}
                onClick={() => this.setState({ results: null })}
              >
                Close
              </Button>,
            ]}
          />
        )}
      </MuiThemeProvider>
    );
  };
}

DestinationSearch.propTypes = { jwt: PropTypes.string };
